import React, { Component } from "react";
import { GET_RC_ENGINE_EXCEL_LIST, GET_RC_EXCEL_LIST, LOGIN_TYPE_ADMIN } from "./helper/Constants";
import Apihelpers from "./helper/ApiHelper";
import { DateRangePicker, Dropdown, Alert } from 'rsuite';
import { NavLink } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
const moment = require('moment-timezone');
const FileDownload = require('js-file-download');


class RCEngineExcelList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      rcexcelDownloadData: [],
      isloading: true
    };
  }

  componentDidMount() {
    let bbuserid = this.props.match.params.someid;
    this.loadRcexcelDownloadData(bbuserid);
  }


  loadRcexcelDownloadData(bbuserid) {
    Apihelpers.getdataresponse(GET_RC_ENGINE_EXCEL_LIST + bbuserid).then(res => {
      if (res.data.status === true) {
        this.setState({
          rcexcelDownloadData: res.data.data,
          isloading: false
        });
      }
      else {
        this.setState({
          rcexcelDownloadData: res.data.data,
          isloading: false
        });
      }
    });
  }


  downloadRCFileResponse = (download_url, type) => {
    console.log(download_url)
    var folder = "output-rcEnginefile/";
    if (type == "input") {
      folder = "input-rcEnginefile/";
    }

    Apihelpers.downloadFileresponse(folder + download_url.split('/')[1]).then(res => {
      FileDownload(res.data, download_url.split("/")[1]);
    }).catch((err) => {
      console.log(err);
    });
  }


  render() {
    const {
      beforeToday,
    } = DateRangePicker;
    return (
      <React.Fragment>
        <div className="wrapper">
          <header className="header">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-auto" style={{ width: "93%" }}>
                  <div className="logo">
                    <a><img src="/assets/images/logo.png" alt="" /></a>
                  </div>
                </div>
                <div style={{ float: "right" }}>
                  <NavLink
                    className="blueBtn btn-sm"
                    to={"/admin/logout"}
                    exact
                    activeClassName="active"
                    style={{ padding: " 5px 10px", fontSize: "12px" }}
                  > LOGOUT
                      </NavLink>
                </div>
              </div>
            </div>
          </header>
          <br /><br /><br />
          <div className="container">
            {this.state.isloading == false ?
              <table className="table">
                <tbody>
                  <tr>
                    <th>Date</th>
                    <th>Input</th>
                    {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN?<th>Input Time</th>:""}
                    {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN?<th>Output Time</th>:""}
                    <th>Count</th>
                    <th>Output</th>
                    <th>Download</th>
                  </tr>
                  {this.state.rcexcelDownloadData.length > 0 ?
                    this.state.rcexcelDownloadData.map((singlercexcelDownloadData, index) => {
                      var gmtDateTime = moment.utc(singlercexcelDownloadData.created_at, "YYYY-MM-DD HH:mm:ss")
                      var gmtDateTimeProcessStart = moment.utc(singlercexcelDownloadData.process_start_at, "YYYY-MM-DD HH:mm:ss")
                      var gmtDateTimeProcessEnd = moment.utc(singlercexcelDownloadData.process_end_at, "YYYY-MM-DD HH:mm:ss")
                      var localIST = gmtDateTime.utcOffset('+05:30').format('DD-MM-YYYY HH:mm:ss')
                      var localISTProcessStart = gmtDateTimeProcessStart.utcOffset('+05:30').format('DD-MM-YYYY HH:mm:ss')
                      var localISTProcessEnd = gmtDateTimeProcessEnd.utcOffset('+05:30').format('DD-MM-YYYY HH:mm:ss')
                      if (localISTProcessStart === "Invalid date" && localISTProcessEnd === "Invalid date") {
                        localISTProcessStart = "Not Process Yet"
                        localISTProcessEnd = "Not Process Yet"
                     }
                      return (
                        <tr key={index}>
                          <td>{localIST}</td>
                          <td>{reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ? <a href="#" onClick={() => this.downloadRCFileResponse(singlercexcelDownloadData.inputfile, 'input')}>{singlercexcelDownloadData.fileOriginalname}</a> : singlercexcelDownloadData.fileOriginalname}</td>
                          {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ? <td>{localISTProcessStart}</td> : null}
                          {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ? <td>{localISTProcessEnd}</td> : null}
                          <td align="center">{(singlercexcelDownloadData.total_records !== undefined && singlercexcelDownloadData.successful_records !== undefined) ? (singlercexcelDownloadData.successful_records + "/" + singlercexcelDownloadData.total_records) : ""}</td>
                          <td>{singlercexcelDownloadData.outputfile.split('/')[1]}</td>
                          <td>
                            {singlercexcelDownloadData.processing_status === "completed" ?
                              <button style={{ fontSize: 11 }} className="yellowBtn" onClick={() => this.downloadRCFileResponse(singlercexcelDownloadData.outputfile, "output")}>Download</button> : <button style={{ fontSize: 11, marginLeft: 15 }} className="" disabled={"disabled"} >Processing</button>}
                          </td>
                        </tr>
                      )
                    })
                    :
                    <tr>
                      <td colSpan="7" align="center">
                        <img src="/assets/images/data-not-found-img.png" width="150" /><br /><br />
                        <b style={{ fontSize: 12 }}>No Data Found</b>
                      </td>
                    </tr>
                  }

                </tbody>
              </table>
              :
              <div className="loader" style={{ display: "block" }}>
                <div className="bg"></div>
                <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
              </div>
            }
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default RCEngineExcelList;
